import moment from 'moment';
import template from './commands.html';

const isSameCommand = (first = {}, second = {}) => {
  return (
    first.name === second.name &&
    first.parameters?.value === second.parameters?.value ||
    first.parameters['write-values'] === second.parameters?.value &&
    moment(first.createdAt).diff(moment(second.createdAt), 'seconds') < 30
    //Hack to get this working for modbus commands write-values prop
  );
};

class CommandsController {
  constructor($interval, dashboardCommandsService) {
    'ngInject';

    this.$interval = $interval;

    this.commandService = dashboardCommandsService;
  }
  $onInit() {
    if (this.active) {
      this.getCommnadsFeedbackHistory(true);
      this.updateHistoryinterval = this.setUpdateHistoryinterval();
    }

    this.commandsValueLookup = this.getcommandsValuesLookup(this.commands);
  }

  setUpdateHistoryinterval() {
    return this.$interval(() => {
      if (!['loading', 'updating'].includes(this.commandsHistoryStatus)) {
        this.getCommnadsFeedbackHistory();
      }
    }, 15000); //15sec
  }

  $onChanges() {
    if (!this.active) {
      this.$interval.cancel(this.updateHistoryinterval);
    }
  }

  $onDestroy() {
    this.$interval.cancel(this.updateHistoryinterval);
  }

  confirm(command, option) {
    if (!this.active || !option) return;

    this.commandService
      .confirm(command, option)
      .then((_) => {
        if (this.active) this.sendDeviceCommand(command, option);
      })
      .catch((_) => {});
  }

  sendDeviceCommand(command, option) {
    this.sendingStatus = 'sending';
    return this.commandService
      .sendCommand(this.asset.id, command, option.value)
      .then((_) => {
        //add the command to ui feedback til it come back in the api call
        this.newCommandFeedbackToShowInUI(command.key, option.value);
      })
      .catch((_) => {
        this.sendingStatus = 'error';
      })
      .finally((_) => {
        this.sendingStatus = '';
      });
  }

  newCommandFeedbackToShowInUI(name, value) {
    this.newCommand = {
      name,
      parameters: { value },
      createdAt: moment().toISOString(),
      status: 'pending',
      statusAt: moment().toISOString(),
    };
    this.commandsHistory = [this.newCommand, ...(this.commandsHistory || [])];
  }

  getCommnadsFeedbackHistory(init) {
    this.commandsHistoryStatus = init ? 'loading' : 'updating';
    return this.commandService
      .getAssetCommandsHistroy(this.asset.id)
      .then((res) => {
        if (this.newCommand) {
          const [firstInList = {}] = res || [];
          if (isSameCommand(firstInList, this.newCommand)) {
            this.newCommand = undefined;
          } else {
            res = [this.newCommand, ...res];
          }
        }

        this.commandsHistory = res;
      })
      .finally((_) => {
        this.commandsHistoryStatus = 'loaded';
      });
  }

  getcommandsValuesLookup(commands) {
    return Object.values(commands || []).reduce((acc, com) => {
      return {
        ...acc,
        ...com.uiParam.constraints.reduce(
          (ac, o) => ({ ...ac, [`${com.key}${o.value}`]: o.label }),
          {},
        ),
      };
    }, {});
  }
}

export default {
  template,
  controller: CommandsController,
  controllerAs: 'cmdVm',
  bindings: {
    asset: '<',
    commands: '<',
    active: '<',
    series: '<',
  },
};
